import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';
import { useAuth } from './AuthContext';

const SocketContext = createContext();

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
};

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [connected, setConnected] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      const apiBase = process.env.REACT_APP_API_URL || '/api';
      const socketUrl = apiBase.startsWith('http')
        ? apiBase.replace('/api', '')
        : window.location.origin;
      const newSocket = io(socketUrl, { path: '/socket.io', withCredentials: true });
      
      newSocket.on('connect', () => {
        console.log('🔌 Connected to WebSocket');
        setConnected(true);
        const userId = user?._id || user?.id;
        if (userId) {
          newSocket.emit('join', userId);
        }
      });

      newSocket.on('disconnect', () => {
        console.log('🔌 Disconnected from WebSocket');
        setConnected(false);
      });

      setSocket(newSocket);

      return () => {
        newSocket.close();
      };
    }
  }, [user]);

  const value = {
    socket,
    connected
  };

  return <SocketContext.Provider value={value}>{children}</SocketContext.Provider>;
};
